import React from 'react';
import { ReCaptcha, loadReCaptcha } from 'react-recaptcha-v3';
import classnames from 'classnames';

import './css/index.scss';

class Contact extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      message: '',
      recaptchaResponse: null,
    };
  }

  componentDidMount() {
    loadReCaptcha(window.__env.recaptchaSiteKey);
  }

  componentDidUpdate(){
    if(this.props.contactSent === true && this.props.contactErrors === null && this.state.message !== ''){
      this.setState({message: ''});
    }
  }

  verifyCallback = (recaptchaToken) => {
    this.setState({recaptchaResponse:recaptchaToken});
  }

  render () {
    return (
      <div className="contactContainer">
        <div className="mainHeader"></div>
        <div className="container">
          <div className="article" style={{ marginTop: '-200px'}}>
            <h1>Contact</h1>
            <div className="contact-box-page">
                <div className="half">
                    <div className="contactLine">
                        {this.props.contactErrors !== null && this.props.contactErrors.name !== undefined ? <div className="error-text">{this.props.contactErrors.name.join(' ')}</div> : null}
                        <input className={classnames({'error': this.props.contactErrors !== null && this.props.contactErrors.name !== undefined})}  onChange={(e)=>{this.setState({name: e.target.value})}} value={this.state.name} type="text" placeholder="nume" />
                    </div>
                    <div className="contactLine">
                        {this.props.contactErrors !== null && this.props.contactErrors.email !== undefined ? <div className="error-text">{this.props.contactErrors.email.join(' ')}</div> : null}
                        <input className={classnames({'error': this.props.contactErrors !== null && this.props.contactErrors.email !== undefined})} onChange={(e)=>{this.setState({email: e.target.value})}} value={this.state.email} type="email" placeholder="email" />
                    </div>
                    <div className="contactLine">
                       {this.props.contactErrors !== null && this.props.contactErrors.message !== undefined ? <div className="error-text">{this.props.contactErrors.message.join(' ')}</div> : null} 
                       <textarea className={classnames({'error': this.props.contactErrors !== null && this.props.contactErrors.message !== undefined})} onChange={(e)=>{this.setState({message: e.target.value})}} value={this.state.message} rows="5" placeholder="mesaj"></textarea>
                    </div>
                    <div className="contactLine">
                        <ReCaptcha
                            sitekey={window.__env.recaptchaSiteKey}
                            action='action_name'
                            verifyCallback={this.verifyCallback}
                            hl="ro"
                        />
                       <button onClick={()=>{this.props.sendContact({name: this.state.name, email: this.state.email, message: this.state.message, recaptchaResponse: this.state.recaptchaResponse})}}>Trimite</button>
                       <div style={{clear: 'both'}}></div>
                       {this.props.contactSent === true && this.props.contactErrors === null ? 
                       <div className="mesaj-succes" style={{marginTop: '30px'}}>Mulțumim pentru mesajul tău!</div> : null}
                       <div style={{clear: 'both'}}>
                       </div>
                    </div>
                </div>
                <div className="half contactImg">

                </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/contact/contact.js